<template>
    <div class="hstack gap-1">
        <label v-if="label != ''">{{ label }}</label>
        <Datepicker
            :model-value="modelValue"
            :format="dateFormat"
            :enable-time-picker="false"
            :utc="true"
            :clearable="true"
            :required="true"
            :input-class-name="'form-control'"
            auto-apply
            @update:model-value="$emit('update:modelValue', $event)">
        </Datepicker>
    </div>
</template>
<script setup lang="ts">
import {defineComponent, watch, ref, defineEmits, defineProps} from "vue";
import type {PropType} from "vue";
import Datepicker from "@vuepic/vue-datepicker";
import {BFilter} from "@/components/BFilterEditor/BFilterEditor.types";

const props = defineProps<{
    items: BFilter[];
    disabled: boolean;
    modelValue: string;
    label: string;
}>();

const filterValue = ref(props.modelValue ?? "");
const dateFormat = "yyyy-MM-dd";

defineEmits<{
    (event: "update:modelValue", value: string): void;
}>();
</script>
